import React, { memo, useEffect } from 'react';

import TopPage from 'v2/components/Shared/TopPage';
import affiliateService from 'v2/services/affiliate';

import Details from './Details';
import Filter from './Filter';
import Table from './Table';

const Affiliate = () => {
  useEffect(() => {
    return () => affiliateService.cleanFilter();
  }, []);

  return (
    <>
      <TopPage title='Meus Afiliados' extra='Gerencie suas solicitações, afiliados aprovados e reprovados.' />

      <Filter />
      <div className='m-4' />
      <Details />
      <Table />
    </>
  );
};

export default memo(Affiliate);
